<div class="card otp-check-card">
  <div class="card-body otp-check-body">
    @if (showTooManyRequestsScreen) {
      <div class="request-rate-limit-screen">
        <p class="request-rate-limit-message">{{ tooManyRequestsMessage }}</p>
      </div>
    } @else if (isAccessBlocked) {
      <div class="otp-lockout">
        <h3 class="otp-lockout-title">Accès verrouillé par sécurité</h3>
        <p class="otp-lockout-copy">
          Suite à plusieurs tentatives infructueuses, votre accès a été verrouillé pour une durée limitée. Passé ce
          délai, vous pourrez à nouveau demander un code pour poursuivre votre souscription.
        </p>

        @if (showLockoutCountdown) {
          <p class="otp-lockout-label">Temps restant avant déverrouillage :</p>
          <p class="otp-lockout-counter">{{ lockoutRemainingText }}</p>
        }
      </div>
    } @else {
      <p class="otp-check-copy">{{ verificationText }}</p>

      <form [formGroup]="form" (ngSubmit)="onValidateOtpCode()">
        <app-otp-form-control
          [parentForm]="form"
          [formControlName]="'code'"
          [title]="''"
          class="no-title otp-input"
          [forceInvalid]="showInvalidCodeError"
          [externalErrorMessage]="invalidCodeMessage"
        >
        </app-otp-form-control>

        @if (showResendTimer && !canRequestNewCode) {
          <p class="otp-helper-text">{{ resendCooldownText }}</p>
        }

        @if (showResendActions && canRequestNewCode) {
          <button type="button" class="resend-link" (click)="toggleExpanded()">
            <fa-icon [icon]="isExpanded ? faChevronDown : faChevronRight" class="resend-icon"></fa-icon>
            Envoyer un nouveau code
          </button>

          @if (isExpanded) {
            <div class="delivery-options">
              <button
                type="button"
                class="delivery-option"
                [disabled]="!canRequestNewCode"
                (click)="onRequestNewCode(channel.Sms)"
              >
                <div class="delivery-icon-wrap">
                  <fa-icon [icon]="faMessage"></fa-icon>
                </div>
                <div class="delivery-content">
                  <div class="delivery-title">SMS</div>
                  <div class="delivery-text">
                    {{ smsText }}
                    <br />
                    <a href="#">Envoyer</a>
                  </div>
                </div>
              </button>

              <!-- todo: del showEmailDeliveryOption | avoid email otp for prospect until the server-side will be improved -->
              @if (showEmailDeliveryOption) {
                <button
                  type="button"
                  class="delivery-option"
                  [disabled]="!canRequestNewCode"
                  (click)="onRequestNewCode(channel.Email)"
                >
                  <div class="delivery-icon-wrap">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </div>
                  <div class="delivery-content">
                    <div class="delivery-title">Email</div>
                    <div class="delivery-text">
                      {{ emailText }}
                      <br />
                      <a href="#">Envoyer</a>
                    </div>
                  </div>
                </button>
              }
            </div>
          }
        }

        <div class="otp-actions" [class.otp-actions-centered]="centerSubmitButton && !showCancel">
          @if (showCancel) {
            <button type="button" class="btn btn-link otp-cancel" (click)="onCancel()">Annuler</button>
          }

          <div class="otp-actions-right">
            <button type="submit" class="btn btn-blue valider" [disabled]="form.invalid || !canSubmitCode">Valider</button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
